<div class="showBg">

  <div class="login-container" style="padding: 20px;">
    <div *ngIf="loginError && !isLoading" class="alert alert-danger small p-2">
      {{loginError | translate}}
    </div>
    <div class="loginLogo"></div>
    <div class="login-card card p-4 shadow">
      <div class="text-center mb-4 text-secondary-purple">{{ 'LOGIN.TITLE' | translate }}</div>
      <form #loginForm="ngForm" (ngSubmit)="onLogin(loginForm)">
        <div class="mb-3">
          <label for="email" class="form-label">{{ 'LOGIN.EMAIL_LABEL' | translate }}</label>
          <input type="email" class="form-control form-control-sm" id="email" name="email" [(ngModel)]="loginData.email"
            [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate" required email #emailInput="ngModel"
            [disabled]="isLoading">
          <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)" class="text-danger mt-1 small">
            <div *ngIf="emailInput.errors?.['required']">{{ 'VALIDATION.EMAIL_REQUIRED' | translate }}</div>
            <div *ngIf="emailInput.errors?.['email']">{{ 'VALIDATION.EMAIL_INVALID' | translate }}</div>
          </div>
        </div>

        <div class="mb-3">
          <label for="password" class="form-label">{{ 'LOGIN.PASSWORD_LABEL' | translate }}</label>
          <input [type]="showPassword ? 'text' : 'password'" class="form-control form-control-sm" id="password"
            name="password" [(ngModel)]="loginData.password" [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
            required minlength="6" #passwordInput="ngModel" [disabled]="isLoading">
          <div *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)"
            class="text-danger mt-1 small">
            <div *ngIf="passwordInput.errors?.['required']">{{ 'VALIDATION.PASSWORD_REQUIRED' | translate }}</div>
            <div *ngIf="passwordInput.errors?.['minlength']">{{ 'VALIDATION.PASSWORD_MINLENGTH' | translate }}</div>
          </div>
        </div>

        <div class="mb-3 form-check">
          <input type="checkbox" class="form-check-input" id="showPasswordCheck" (change)="toggleShowPassword()"
            [disabled]="isLoading"> <label class="form-check-label" for="showPasswordCheck">{{ 'LOGIN.SHOW_PASSWORD' |
            translate }}</label>
        </div>



        <button type="submit" class="btn button-primary-purple w-100 btn-sm"
          [disabled]="loginForm.invalid || isLoading">
          <span *ngIf="isLoading; else loginButtonText">
            {{ 'LOGIN.LOGGING_IN_BUTTON' | translate }} <span class="spinner-border spinner-border-sm" role="status"
              aria-hidden="true"></span>
          </span>
          <ng-template #loginButtonText>{{ 'LOGIN.LOGIN_BUTTON' | translate }}</ng-template>
        </button>
      </form>

      <div class="text-center mt-3">
        <p>{{ 'LOGIN.REGISTER_NOW_PROMPT' | translate }} <span style="text-decoration: underline"><a
              routerLink="/register" [class.disabled-link]="isLoading">{{
              'LOGIN.REGISTER_NOW_LINK' | translate }}</a></span> </p>
      </div>
      <div class="text-center " style="text-decoration: underline">
        <a routerLink="/forgot-password" class="text-decoration-none small" [class.disabled-link]="isLoading">
          {{ 'FORGOT_PASSWORD.FORGOT_PASSWORD_LINK' | translate }} </a>
      </div>
    </div>
  </div>
</div>